<template>
  <div>
    <div class="p16 flex-row">
      <div>
        <span class="cur" @click="back"><i class="el-icon-arrow-left"></i>返回</span>
        <el-divider direction="vertical"  class="color999"></el-divider>
        <span class="color999 cur" @click="back">验劵核销&nbsp;/&nbsp;</span>
      </div>
      <div>登记成功</div>
    </div>
    <div class="hexiao">
      <div class="header-title">登记成功</div>
      <div class="moneys header-info">请复制下方券码，打开{{$route.query.appName}}核销</div>
      <div class="qrCode">{{this.$route.query.qrcode}}<span class="copyCode ml10" @click="copyCode">复制</span></div>
      <div>
        <vue-qr :text="downloadData.url" :margin="10" colorDark="#000" colorLight="#fff" :logoScale="0.3" :size="200"></vue-qr>
      </div>
      <div class="mains-bottoms">
        <el-button @click="back">返回上一页</el-button>
        <el-button type="primary" @click="look">查看详情</el-button>
        <!-- <paging :currentPage="query.start" :totalCount="totalCount" @doPageQuery="doPageQuery"></paging> -->
      </div>
      <edit-set ref="editForm" @change="refreshPage"></edit-set>
    </div>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import vueQr from 'vue-qr';
import editSet from "./detail";
export default {
  mixins: [minxin],
  components: {
    vueQr,
    editSet
  },
  data() {
    return {
      downloadData: {
        url: this.$route.query.qrcode || ''
      }
    };
  },
  created() {
    
  },
  mounted() {
    
  },
  methods: {
    back() {
      let obj = JSON.parse(sessionStorage.getItem("verification"))
      let parmar = {
        payWayCode: obj.payWayCode,
        menuName: obj.menuName,
        appName: obj.appName,
        menuCode: obj.menuCode
      }
      this.$router.push({
        path: '/collectMoney/verification',
        query: parmar
      });
    },
    copyCode () {
      navigator.clipboard.writeText(this.$route.query.qrUrl)
      this.$message.success("复制成功")
    },
    look () {
      // navigator.clipboard.writeText(text)
      this.$refs["editForm"].$emit("set", this.$route.query.qrUrl);
    },
    refreshPage () {
      
    }
  }
};
</script>
<style>
.payway-success .el-button + .el-button {
  margin-left: 0;
}
</style>
<style scoped lang="less">
@import "../../../assets/css/edit.less";
.hexiao {
  height: calc(100vh - 130px);
  margin: 0 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #FFFFFF;
  border-radius: 10px;
  .header-title {
    margin-top: 8%;
    font-size: 24px;
  }
  .header-info {
    padding: 30px;
  }
  .qrCode {
    font-size: 24px;
    margin-bottom: 10px;
  }
  .copyCode {
    display: inline-block;
    padding: 3px 5px;
    border-radius: 5px;
    font-size: 16px;
    background: #336fed;
    color: #fff;
  }
}
.mains-bottoms {
  background-color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 20px;
  margin-top: 60px;
  .back {
    margin: 10px 20px;
  }
}
</style>
